import { useCallback } from 'react';

import { OneInchQuoteInfo, UpdateQuoteParams } from '../../services/types';
import { getOneInchQuote } from '../../services/update';

export const useUpdateOneInchQuote = (): ((params: UpdateQuoteParams) => Promise<OneInchQuoteInfo>) => {
  // is defined as hook to allow for protocol-dependent settings

  return useCallback(async (params: UpdateQuoteParams) => {
    try {
      return await getOneInchQuote(params);
    } catch (e) {
      console.error(e);
      throw e;
    }
  }, []);
};
